module.exports = __webpack_public_path__ + "static/battle_06-7c64db224ec73fa0035a9901fb991f63.jpg";